import constants from '../config/constants'
import {
  dateFromBackEndToFrontendFormat,
  dateToFrontEndFormat,
  dateToHoursFormat,
  dateToDayFormat,
} from './dates'

/**
 * Format the passenger obj
 * @param {Object} passenger
 * @returns {Object}
 */
export const formatPassenger = passenger => {
  const dateOfBirth = passenger.dateOfBirth
    ? dateFromBackEndToFrontendFormat(passenger.dateOfBirth)
    : ''

  // Store infant in object so if no infant is there,
  // no infant property is added to the object
  const infant = passenger.infant
    ? { infant: formatInfant(passenger.infant) }
    : null

  return {
    ssrs: [],
    ...passenger,
    dateOfBirth,
    ...infant,
  }
}

/**
 * Format the infant obj
 * @param {Object} infant
 * @returns {Object}
 */
export const formatInfant = infant => {
  const dateOfBirth = infant.dateOfBirth
    ? dateFromBackEndToFrontendFormat(infant.dateOfBirth)
    : ''

  return {
    ...infant,
    dateOfBirth,
  }
}

/**
 * Format the flight details obj
 * @param {Object} flightDetails
 * @returns {Object}
 */
export const formatFlightDetails = flightDetails => {
  const departureDate = dateToFrontEndFormat(
    flightDetails.departure,
    constants.stdDateFormat
  )
  const departureTime = dateToHoursFormat(
    flightDetails.departure,
    constants.stdDateFormat
  )
  const departureDay = dateToDayFormat(
    flightDetails.departure,
    constants.stdDateFormat
  )

  const arrivalDate = dateToFrontEndFormat(
    flightDetails.arrival,
    constants.stdDateFormat
  )
  const arrivalTime = dateToHoursFormat(
    flightDetails.arrival,
    constants.stdDateFormat
  )
  const arrivalDay = dateToDayFormat(
    flightDetails.arrival,
    constants.stdDateFormat
  )

  return {
    ...flightDetails,
    departureDate,
    departureTime,
    departureDay,
    arrivalDate,
    arrivalTime,
    arrivalDay,
  }
}

/**
 * Format the delete passenger flight info object
 * @param {Object} flightDetail
 * @returns {Object}
 */
export const formatPassengerDeleteFlightData = flightDetail => {
  const inbound = flightDetail.inbound
    ? { inbound: formatFlightDetails(flightDetail.inbound) }
    : null
  const outbound = flightDetail.outbound
    ? { outbound: formatFlightDetails(flightDetail.outbound) }
    : null

  return {
    ...flightDetail,
    ...inbound,
    ...outbound,
  }
}
